/**
 * @generated SignedSource<<469e5ec15f0d969df65dd8748bbbddfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "OPPORTUNITIES" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TimesheetsFilters_viewer$data = {
  readonly id: string;
  readonly calendarIntegrations: {
    readonly googleCalendar: {
      readonly calendarFetchEnabled: boolean | null;
    } | null;
    readonly outlookCalendar: {
      readonly calendarFetchEnabled: boolean | null;
    } | null;
  } | null;
  readonly filters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "TimesheetsFilters_viewer";
};
export type TimesheetsFilters_viewer$key = {
  readonly " $data"?: TimesheetsFilters_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimesheetsFilters_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "calendarFetchEnabled",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "filters"
        ]
      }
    ]
  },
  "name": "TimesheetsFilters_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarIntegrations",
      "kind": "LinkedField",
      "name": "calendarIntegrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarIntegration",
          "kind": "LinkedField",
          "name": "googleCalendar",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarIntegration",
          "kind": "LinkedField",
          "name": "outlookCalendar",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "filters",
      "args": null,
      "concreteType": "FilterTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_filters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Filter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "section",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "49dd78537d66b0bca9cdf50d15c07577";

export default node;
